import { useId, type InputHTMLAttributes } from "react";
import styles from "./Input.module.css";

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "id"> & {
  label: string;
  /** Текст ошибки под полем; поле подсвечивается и помечается `aria-invalid`. */
  error?: string;
  hint?: string;
};

/** Input / Text Field из Figma (узел 34:1681): Default, Focused, Filled, Error, Disabled. */
export function Input({ label, error, hint, className, ...rest }: InputProps) {
  const id = useId();
  const errorId = `${id}-error`;
  const hintId = `${id}-hint`;
  return (
    <div className={[styles.field, className].filter(Boolean).join(" ")}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <input
        {...rest}
        id={id}
        className={styles.input}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : hint ? hintId : undefined}
      />
      {error && (
        <p className={styles.error} id={errorId}>
          {error}
        </p>
      )}
      {!error && hint && <p className={styles.hint} id={hintId}>{hint}</p>}
    </div>
  );
}
